import { useRef } from "react";
import { useSetState } from "ahooks";
import { message } from "antd";
import { SActionBtn, SLowcodeList, SMessage, STableActions } from "shj-components";
import {getConfig} from './config.tsx'
import { getProductCommonPage, warningRulesDelete, warningRulesPage } from "@/services/product.ts";
import { httpOrgList } from "@/services/homeService.ts";
import DebounceSearchSelect from "@/pages/baseProduct/components/DebounceSearchSelect";
import { apiData2Table } from "@/utils/data.ts";
import { AddOrEditModal } from "./addOrEditModal.tsx";
const GeneralRuleTable = () => {
  const listRef = useRef();
  const [state, setState] = useSetState({
    open: false,
    record: {},
  })

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      warningRulesPage({
        data: {
          ...query,
          ruleType: 'STANDARD_CONFIG',
          orderBys: [{
            columnName: 'CREATED_TIME',
            asc: false,
          }]
        },
        params: {pageSize, pageId: current}
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject);
    })
  }

  const getOptions = async () => {
    const companyList = await httpOrgList({status: undefined})
    return {companyList: [{ name: '通用', id: '0' }, ...companyList]}
  }

  const onAddOrEdit = (record = {}) => {
    setState({open: true, record})
  }

  const onDel = (record) => {
    onBatchDel({ selectedRowKeys: [record.id] }, false)
  }

  const onBatchDel = ({selectedRowKeys}, isBatch = true) => {
    console.log(selectedRowKeys)
    SMessage.confirm({
      title: isBatch ? '确认删除所选通项标配预警规则吗？' : '确认删除该通项标配预警规则吗？',
      content: `配置修改后，将于次日生效`,
      onOk: () => {
        warningRulesDelete({ ids: selectedRowKeys }).then(res => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      }
    })
  }

  const extensions = {
    searchMode: 'group',
    request: {fetchList, getOptions},
    events: {onAdd: () => onAddOrEdit(), onBatchDel},
    customRender: {
      actionRender(_, record){
        return <STableActions>
          <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
          <SActionBtn danger onClick={() => onDel(record)}>删除</SActionBtn>
        </STableActions>
      },
      searchSelectRender({ name, form }) {
        return (
          <DebounceSearchSelect
            allowClear
            label={'产品'}
            isCommon={true}
            fetchOptions={getProductCommonPage}
            fixedParams={{
              prodTypes: [ 'PRODUCT_PACKAGE'],
              enabled: undefined,
            }}
            onChange={v => form.setFieldsValue({ [name]: v })}
            fieldNames={{ label: 'prodName' }}
            style={{ width: '100%' }}
          />
        )
      },
    }
  }

  return <>
    <SLowcodeList ref={listRef} config={getConfig()} {...extensions}/>
    {state.open && <AddOrEditModal
        open={state.open}
        record={state.record}
        onClose={() => setState({open: false, record: {}})}
        onReload={listRef.current?.reload}
    />}
  </>
}

export default GeneralRuleTable